import temaPadrao from "_config/temas/estilo/base";
import { PrimaryButton } from "components/Button/style";
import { Informacao } from "components/Informacao";
import { ModalCustom } from "components/ModalCustom";
import { Required } from "components/Required";
import FileUpload from "components/UploadArquivos";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import {
  IErroLinhaPlanilha,
  IResultadoImportacaoPlanilha,
} from "../../interfaces/IResultadoImportacaoPlanilha";
import { ContainerArquivo, ContainerBotoes, TextoDescricao } from "./style";

const NOME_PLANILHA_MODELO = "Modelo_solicitacao_placa.xlsx";
const CAMINHO_PLANILHA_MODELO = `/app/files/${NOME_PLANILHA_MODELO}`;
const ID_INPUT_ARQUIVO = "arquivoPlanilhaSolicitacaoManual";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirmar: (arquivo: File) => Promise<IResultadoImportacaoPlanilha>;
  carregando: boolean;
}

export function SolicitarManualmenteModal({
  show,
  handleClose,
  onConfirmar,
  carregando,
}: IProps) {
  const [arquivo, setArquivo] = useState<File | null>(null);
  const [mensagemErro, setMensagemErro] = useState("");
  const [erros, setErros] = useState<IErroLinhaPlanilha[]>([]);
  const [chaveInput, setChaveInput] = useState(0);

  function limparErros() {
    setMensagemErro("");
    setErros([]);
  }

  function fechar() {
    setArquivo(null);
    limparErros();
    handleClose();
  }

  async function confirmar() {
    if (!arquivo) {
      return;
    }
    const resultado = await onConfirmar(arquivo);
    if (resultado.sucesso) {
      fechar();
      return;
    }
    setMensagemErro(resultado.mensagem ?? "");
    setErros(resultado.erros);
    setArquivo(null);
    setChaveInput((chave) => chave + 1);
  }

  function baixarModelo() {
    const link = document.createElement("a");
    link.download = NOME_PLANILHA_MODELO;
    link.href = CAMINHO_PLANILHA_MODELO;
    link.click();
  }

  const fecharSeLivre = carregando ? () => {} : fechar;

  return (
    <ModalCustom
      show={show}
      handleClose={fecharSeLivre}
      title="Solicitar manualmente"
      centered
      footer
      footerTools={
        <ContainerBotoes>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={fecharSeLivre}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={baixarModelo}
          >
            Baixar modelo <FaDownload />
          </PrimaryButton>
          <PrimaryButton
            type="button"
            variante="primary"
            onClick={confirmar}
            disabled={!arquivo || carregando}
          >
            Enviar
          </PrimaryButton>
        </ContainerBotoes>
      }
    >
      <TextoDescricao>
        Realize o upload da planilha para seguir com a solicitação.
      </TextoDescricao>
      <ContainerArquivo>
        <Form.Label
          htmlFor={ID_INPUT_ARQUIVO}
          style={{ color: temaPadrao.colors.neutral.neutral70 }}
        >
          Arquivo <Required />
        </Form.Label>
        <FileUpload
          key={chaveInput}
          id={ID_INPUT_ARQUIVO}
          inputAccept=".xlsx,.xls"
          comMaxWidth={false}
          textoBotao=""
          onFileUpload={(selecionado) => {
            limparErros();
            setArquivo(selecionado);
          }}
        />
      </ContainerArquivo>
      {mensagemErro && (
        <Informacao
          type="erro"
          showLabel={false}
          showBotaoFechar={false}
          className="mt-3"
          mensagem={
            <>
              <strong>{mensagemErro}</strong>
              {erros.length > 0 && (
                <ul
                  className="mb-0 mt-2"
                  style={{ maxHeight: 240, overflowY: "auto" }}
                >
                  {erros.map((erro) => (
                    <li key={erro.linha}>
                      Linha {erro.linha}
                      {erro.placa ? ` (${erro.placa})` : ""}:{" "}
                      {erro.mensagens.join(", ")}
                    </li>
                  ))}
                </ul>
              )}
              <span className="d-block mt-2">
                Corrija a planilha e selecione o arquivo novamente.
              </span>
            </>
          }
        />
      )}
    </ModalCustom>
  );
}
